const stage = import.meta.env.VITE_STAGE || import.meta.env.MODE

let prefEnv = 'staging'
if (import.meta.env.VITE_ABEL == 'true') prefEnv = 'development'

const actualEnv = stage === 'development' ? prefEnv : stage
let domain
let protocol = 'https://'
switch (actualEnv) {
	case 'development':
		domain = 'localhost:3000/api/admin'
		protocol = 'http://'
		break
	case 'test':
		domain = 'testapi.eitje.app/api/admin'
		break
	case 'test2':
		domain = 'eitje-test-api2.eitje.app/api/admin'
		break
	case 'monthly_mirror':
		domain = 'monthly-mirror.eitje.app/api/admin'
		break
	case 'thursday_mirror':
		domain = 'thursday-mirror.eitje.app/api/admin'
		break
	case 'staging':
		domain = 'staging-api.eitje.app/api/admin'
		break
	case 'mirror':
		domain = 'mirror-api.eitje.app/api/admin'
		break
	case 'production':
		domain = 'api.eitje.app/api/admin'
		break
	default:
		domain = 'api.eitje.app/api/admin'
}

export const ENV = actualEnv
export const DOMAIN = domain
export const HOST = `${protocol}${domain}`
export const fileDomain = HOST.replace('app/api/admin', 'app')
